import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Grid,
  Card,
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  Snackbar,
  Alert,
} from "@mui/material";
import { API_ENDPOINTS } from "../../../config/api";

const CreateUserTypeForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    publish: false,
  });

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const navigate = useNavigate();

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API_ENDPOINTS.USER_TYPES.CREATE, {
        name: formData.name,
        publish: formData.publish,
      });
      setSnackbar({
        open: true,
        message: "User Type created successfully!",
        severity: "success",
      });
      // Add a small delay before navigation to show the success message
      setTimeout(() => {
        navigate("/user-types");
      }, 1000);
    } catch (error) {
      console.error("Error creating user type:", error.response?.data || error.message);
      setSnackbar({
        open: true,
        message: "Error creating user type: " + (error.response?.data?.message || "Something went wrong"),
        severity: "error",
      });
    }
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Card sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Add User Type
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <TextField
                    label="User Type Name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name="publish"
                      checked={formData.publish}
                      onChange={handleChange}
                    />
                  }
                  label="Publish"
                />
              </Grid>
            </Grid>
            <Box mt={2}>
              <Button type="submit" variant="contained">
                Create User Type
              </Button>
            </Box>
          </Card>
        </Grid>
      </Grid>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateUserTypeForm;